import React, { useState, useEffect } from 'react';
import axios from '../../axiosdata';
import classes from './ShoutboxControls.module.css';

function BlockedUsersPanel() {

    const [blockedUsers, setBlockedUsers] = useState({});

    useEffect(() => {
        axios.get('/blocked_users.json')
            .then(res => { if (res.data) setBlockedUsers(res.data); else setBlockedUsers({}); })
            .catch(err => console.error('Error fetching blocked users:', err));
    }, []);

    const unblockUser = (uid) => {
        axios.delete(`/blocked_users/${uid}.json`)
            .then(() => setBlockedUsers(prev => {
                const updated = { ...prev };
                delete updated[uid];
                return updated;
            }))
            .catch(err => console.error('Error unblocking user:', err));
    };

    const blockedEntries = Object.entries(blockedUsers);

    return (
        <div className={classes.control_panel}>
            <div className={classes.blockedSection}>
                <h4>Estetyt käyttäjät ({blockedEntries.length})</h4>
                {blockedEntries.length === 0
                    ? <p className={classes.noBlocked}>Ei estettyjä käyttäjiä.</p>
                    : blockedEntries.map(([uid, data]) => (
                        <div key={uid} className={classes.blockedEntry}>
                            <span className={classes.blockedName}>{data.username || uid}</span>
                            <span className={classes.blockedUid}>{uid}</span>
                            <button className={classes.unblockButton} onClick={() => unblockUser(uid)}>Poista esto</button>
                        </div>
                    ))
                }
            </div>
        </div>
    );
}

export default BlockedUsersPanel;
